import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import Loading from '../../components/loading/loading';
import ErrorDisplay from '../../components/error-display/error-display';
import DropOffLocationQRCode from '../../components/drop-off-location-qr-code/drop-off-location-qr-code';

import GET_QRCODE from '../../gql/get-qrcode.gql.js';
import useDre20Params from '../../hooks/use-dre20-params.js';

export default function QRCodeView() {
  const { orderNumber, orderEmail} = useDre20Params();
  const skip = !orderNumber || !orderEmail;
  const { loading, error, data } = useQuery(GET_QRCODE, {
    variables: {
      orderId: orderNumber,
      email: orderEmail,
      count: 0,
    },
    skip,
  });

  const linkLabelText = useMemo(() => {
    const dropoffLocationsLinkChild = data?.returnedOrder?.returnMethod?.children?.find(child => Boolean(child.dropoffLocationsLink));
    return dropoffLocationsLinkChild?.dropoffLocationsLink;
  }, [data]);

  return (
    <div data-testid="qrcode-view" className="qrcode-view">
      { loading && <Loading />}
      { error && <ErrorDisplay error={error} />}
      { data && (
        <>
          <div className="qr-code-return-details">
            <span
              className="qr-code-return-details-text"
              data-property={data.returnedOrder.confirmationDetails.qrCodeReturnDetailsTmnt}
              data-testid="qr-code-return-details-text"
              dangerouslySetInnerHTML={{ __html: data.returnedOrder.confirmationDetails.qrCodeReturnDetailsText }}
            />
          </div>
          <DropOffLocationQRCode
            rmaNumber={data.returnedOrder.encodedOrderDetails}
            showRmaNumber={false}
            searchUrl={data.returnedOrder.returnMethod.mapUrl}
            linkLabelText={linkLabelText}
          />
        </>
      )}
    </div>
  );
}